import { useEffect, useState } from "react";
import { Toast, ErrorBlock, DotLoading } from 'antd-mobile'
import { Route, Switch, useRouteMatch, useLocation } from "react-router-dom";
import ApplyInformation from "./page/w2";
import VehstageInformation from "./page/w3";
import BankCard from "./page/w1";
import Material from './page/w4'
import W5 from './page/w5'
import { getfzzt } from "@src/service/ownService";
import store from '@src/util/store'
import { gotor } from "@src/route";
export default function () {
  const location = useLocation();
  // if (location.pathname.indexOf('/w1')!=-1){
  //   store.remove('loanid')
  // }
  const loanid =  store.get('loanid')
  const [nodeNel, setNodeNel] = useState<any>(<ErrorBlock style={{'--image-height-full-page': '100px'}} fullPage description={<DotLoading color='primary' />} title="" status='busy' />)
  const { path } = useRouteMatch()
  const rou = <Switch>
    <Route path={`${path}/w1`} component={BankCard} />
    <Route path={`${path}/w2`} component={ApplyInformation} />
    <Route path={`${path}/w3`} component={VehstageInformation} />
    <Route path={`${path}/w4`} component={Material} />
    <Route path={`${path}/w5`} component={W5} />
  </Switch>
  useEffect(() => {
    if (loanid&&(location.pathname.indexOf('/w5')==-1)) {
      getfzzt(loanid).then(res => {
        if (res.status != 0) {
          Toast.show({
            content: '当前分期申请办理中，不可修改资料',
            maskClickable: false,
            duration: 1000,
            afterClose: () => {
              gotor('/order')
            }
          })
        } else {
          setNodeNel(rou)
        }
      }).catch(() => {
        setNodeNel(rou)
      })
    } else {
      setNodeNel(rou)
    }
  }, [location])
  return nodeNel
}